import { Client } from "@core/Client";
import { PlayboardMode } from "./Links/IMAXA/IMAXAProtocol";


export enum BetType {
	BET_NONE,
	BET_PLAIN, /*Plain bet on 1 number*/
	BET_CAVAL, /*Bet on two neighbur numbers*/
	BET_TRASV, /*Bet on three neigbur numbers*/
	BET_CARRE, /*Bet on four neigbur numbers*/
	BET_FIFTH, /*Bet on five neigbur numbers only on double zerro*/
	BET_SIXTH, /*Bet on six neigbur numbers*/
	BET_HLINE, /*Bet on 12 numbers on a horizontal line*/
	BET_THIRD, /*Bet on 12 numbers a third of the play board*/
	BET_COLOR, /*Bet on 18 numbers of the same color no zerro*/
	BET_ODEVN, /*Bet on 18 numbers odds or evens no zerro*/
	BET_PHALF, /*Bet on 18 numbers playboard half 1-18 or 19-36 no zerro*/
	BET_FIGURE,/*Bet on figure*/
	BET_TAUTVA /*All in on figure*/
}

export class BetTypeInfo {
	Type: BetType
	Name: String
	Multiplier: number

	constructor(betTypeInfoObj: any) {
		this.Type = betTypeInfoObj["index"]
		this.Name = betTypeInfoObj["name"]
		this.Multiplier = betTypeInfoObj["multiplier"]
	}
}

export class BetFieldInfo {
	Type: BetType
	CoveredNumbers: number[]

	constructor(betTypeInfoObj: any) {
		this.Type = betTypeInfoObj["type"]
		this.CoveredNumbers = betTypeInfoObj["numbers"]
	}
}

export class Stake {
	private Limits: Array<number>;
	private Minimals: Array<number>;

	public static get MAX_BETTING_CHIPS_COUNT(): number { return 6; }

	constructor(stakeObj: any) {
		this.Limits = stakeObj['betTypeMax'];
		this.Minimals = stakeObj['betTypeMin'];
		this.PlayBoardLimitMax = stakeObj['playboardMax'];
		this.PlayBoardLimitMin = stakeObj['playboardMin'];
		this.BetsCountMax = stakeObj['maxNumBets'];
		this.MaxTableWinLimit = stakeObj['maxWin'];
		this.ChipValues = stakeObj['chipValues'];
		this.MultiplierOverrides = stakeObj['multiplierOverrides'];
	}

	PlayBoardLimitMin: number;
	PlayBoardLimitMax: number;
	BetsCountMax: number;
	MaxTableWinLimit: number;
	ChipValues: Array<number>;
	MultiplierOverrides:object ;

	public getMinBet(type: BetType): number {
		if (type == BetType.BET_NONE) return 0;
		return this.Minimals[type - 1];
	}

	public getMaxBet(type: BetType): number {
		if (type == BetType.BET_NONE) return 0;
		return this.Limits[type - 1];
	}
}
export class BetTable {
	public static get BETS_TABLE_MAX_X(): number {
		if (Client.logic.setup.playboardMode == PlayboardMode.NORMAL)
			return 26
		else if (Client.logic.setup.playboardMode == PlayboardMode.LESFIGURES_PLUS)
			return 28;
	} //26 normal +2 for les figures

	public static get BETS_TABLE_MAX_Y(): number {
		return 11;
	} //x:26,27 -> y:0->8 for les figures , 26th is bottom 8:1 , 27th is TautVA

	public doubleZero: boolean

	Fields: BetField[][]

	constructor() {
		this.doubleZero = Client.logic.setup.DoubleZero;

		this.Fields = []
		for (let i = 0; i < BetTable.BETS_TABLE_MAX_X; i++) {
			this.Fields[i] = []
			for (let j = 0; j < BetTable.BETS_TABLE_MAX_Y; j++) {
				this.Fields[i][j] = new BetField(Client.logic.setup.BetFields[i][j])
			}
		}
	}

	public forEveryPosition(worker: (field: BetField, x: number, y: number) => void) {
		for (let i = 0; i < BetTable.BETS_TABLE_MAX_X; i++) {
			for (let j = 0; j < BetTable.BETS_TABLE_MAX_Y; j++) {
				worker(this.Fields[i][j], i, j)
			}
		}
	}
}

export class BetField {
	constructor(public Info: BetFieldInfo) {
		this.BetCredit = 0
		this.HiddenCredit = 0 //hidden credits are credits that are not visible to the player or sent to yserver but placed on this field for limit calculations and various displays - such placed credits are sent to yserver as a standalone object not part of the main bet array
		this.WonCredit = 0
		this.betMemoryGame_virtual = 0
		this.betRepeatBets_virtual = 0
		this.FieldEnabled = true

		this.SimulateWinCredit = 0
		this.SimulateBetMoney = 0.0
	}

	BetCredit: number
	WonCredit: number
	HiddenCredit: number

	betRepeatBets_virtual: number
	betMemoryGame_virtual: number

	SimulateWinCredit: number
	SimulateBetMoney: number

	FieldEnabled: boolean = true
}